export function humanizeKey(value: string | null | undefined): string {
  if (!value) return ''
  return value
    .split(/[_\s]+/u)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
